import React, {useState} from 'react';
import {setShowDialog, store} from '../../utils/redux';
import {MyInput} from '../../utils/utils'

// Rein clientseitige Sicherung gegen versehentliches Hochladen, kein echter Zugriffsschutz
// (der Wert landet im ausgelieferten JS-Bundle) - bei Bedarf hier anpassen
const UPLOAD_PASSWORD = 'luchs'

export default function UploadDlg({onConfirm}) {
    const [password, setPassword] = useState('')
    const [error, setError] = useState(false)

    const confirm = () => {
        if (password === UPLOAD_PASSWORD) {
            store.dispatch(setShowDialog(false))
            onConfirm()
        } else {
            setError(true)
        }
    }

    return (<div style={{background: 'white', padding: '20px', borderRadius: '8px', display: 'flex', flexDirection: 'column', gap: '10px', alignItems: 'center'}}>
        <p style={{margin: 0}}>Passwort zum Hochladen eingeben</p>
        <MyInput
            type="password"
            value={password}
            set={val => {
                setPassword(val)
                setError(false)
            }}
            onKeyDown={e => e.key === 'Enter' && confirm()}
            autoFocus/>
        {error && <p style={{color: 'red', margin: 0}}>Falsches Passwort</p>}
        <div style={{display: 'flex', justifyContent: 'space-evenly', width: '100%'}}>
            <button onClick={() => store.dispatch(setShowDialog(false))}>Abbrechen</button>
            <button onClick={confirm}>Hochladen</button>
        </div>
    </div>)
}
